/** What tells two files apart as videos, whatever their names or containers. */
export interface VideoIdentity {
  readonly durationSec: number;
  readonly width: number;
  readonly height: number;
}

/** Galleries may hand back a re-saved copy (e.g. iOS converting HEVC to H.264), whose length differs by a few frames. */
const DURATION_TOLERANCE_SEC = 0.15;
const DURATION_TOLERANCE_RATIO = 0.005;

/**
 * Whether `candidate` is the video being edited, picked again: the same
 * picture size and the same length. Every edit is kept in source time, so
 * this is what has to match for cuts, blurs and captions to land where they were.
 */
export function isSameVideo(original: VideoIdentity, candidate: VideoIdentity): boolean {
  if (original.width !== candidate.width || original.height !== candidate.height) return false;
  const tolerance = Math.max(DURATION_TOLERANCE_SEC, original.durationSec * DURATION_TOLERANCE_RATIO);
  return Math.abs(original.durationSec - candidate.durationSec) <= tolerance;
}
